var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0367 0.00195312H6.97555C2.60533 0.00195312 0 2.60728 0 6.97751V17.0266C0 21.4089 2.60533 24.0142 6.97555 24.0142H17.0247C21.3949 24.0142 24.0002 21.4089 24.0002 17.0386V6.97751C24.0122 2.60728 21.4069 0.00195312 17.0367 0.00195312Z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8947 10.8967H13.1053V6.10722C13.1053 5.50301 12.6042 5.00195 12 5.00195C11.3958 5.00195 10.8947 5.50301 10.8947 6.10722V10.8967H6.10526C5.50105 10.8967 5 11.3977 5 12.002C5 12.6062 5.50105 13.1072 6.10526 13.1072H10.8947V17.8967C10.8947 18.5009 11.3958 19.002 12 19.002C12.6042 19.002 13.1053 18.5009 13.1053 17.8967V13.1072H17.8947C18.4989 13.1072 19 12.6062 19 12.002C19 11.3977 18.4989 10.8967 17.8947 10.8967Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSquare);
export default __webpack_public_path__ + "static/media/add-square.79640f4654326efe5efe3a5b3621d687.svg";
export { ForwardRef as ReactComponent };